var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoreIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Category",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M14.286,20a2.459,2.459,0,0,1-2.449-2.47V14.237a2.46,2.46,0,0,1,2.449-2.471h3.266A2.46,2.46,0,0,1,20,14.237V17.53A2.459,2.459,0,0,1,17.552,20ZM2.449,20A2.459,2.459,0,0,1,0,17.53V14.237a2.46,2.46,0,0,1,2.449-2.471H5.714a2.46,2.46,0,0,1,2.449,2.471V17.53A2.459,2.459,0,0,1,5.714,20ZM14.286,8.234a2.46,2.46,0,0,1-2.449-2.47V2.47A2.46,2.46,0,0,1,14.286,0h3.266A2.459,2.459,0,0,1,20,2.47V5.765a2.46,2.46,0,0,1-2.448,2.47Zm-11.837,0A2.46,2.46,0,0,1,0,5.765V2.47A2.46,2.46,0,0,1,2.449,0H5.714A2.46,2.46,0,0,1,8.163,2.47V5.765a2.46,2.46,0,0,1-2.449,2.47Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreIcon);
export default __webpack_public_path__ + "static/media/core-icon.90db5fb88117a46288f3f102065d436a.svg";
export { ForwardRef as ReactComponent };